<!--
 * @Author: zhangxx 2425792130@qq.com
 * @Date: 2025-07-29 19:12:26
 * @LastEditors: zhangxx 2425792130@qq.com
 * @LastEditTime: 2025-08-05 17:49:59
 * @FilePath: \original-pc-toB-bookstores-red(ToB书城PC版红色)\src\views\readHome\readingHome.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class="reading-home">
        
        <div class="contents">
            <div class="banner" v-if="home_page_banner!=''">
                <el-carousel
                    :interval="5000"
                    type="card"
                    height="375px"
                    indicator-position="none"
                    >
                    <el-carousel-item v-for="item in  home_page_banner">
                        <img
                        style="width: 100%; height: 100%; border-radius: 4px"
                         @click="GoToDetail(item.skip_type, item.skip_target)"
                        :src="item.img_url"
                        alt=""
                        />
                    </el-carousel-item>
                </el-carousel>
            </div>
            <!-- 主题书单 -->
            <div v-if="showCrop.isShowTheme == 'Y'">
                <div class="theme-list">
                    <h3>主题书单</h3>
                    <span @click="goPath('/read/themeBook')">查看更多</span>
                </div>
                <div class="bookList">
                    <EmptyData v-if="themelist.length === 0" />
                    <div class="book-item" v-for="item in themelist" :key="item.ID" @click="goPath(`/read/booklistDetails?id=${item.ID}&bookListID=${item.groupID}`)">

                        <img class="imgs" :src="item.imgUrl" alt="" @error="handleError">
                        <h3 class="tit" :title="item.groupName">{{ item.groupName }}</h3>
                        <div class="book-icons">
                            <div class="icon-item" v-if="item.relaCount.bookCount">
                                <img src="../../assets/readimg/books.svg" alt="" class="icon-placeholder">
                                <span>{{ item.relaCount.bookCount }}本</span>
                            </div>
                            <div class="icon-item" v-if="item.relaCount.audioCount">
                                <img src="../../assets/readimg/ear.svg" alt="" class="icon-placeholder">
                                <span>{{ item.relaCount.audioCount }}本</span>
                            </div>
                            <div class="icon-item" v-if="item.relaCount.videoCount">
                                <img src="../../assets/readimg/list.svg" alt="" class="icon-placeholder">
                                <span>{{ item.relaCount.videoCount }}门</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 闲翻书 -->
            <div v-if="showCrop.isShowLeisure == 'Y'">
                <div class="theme-list">
                    <h3>闲翻书</h3>
                    <span @click="goPath('/read/idleFlipBook')">查看更多</span>
                </div>
                <div class="bookList">
                    <EmptyData v-if="idleFlipBook.length === 0" />
                    <div 
                        v-for="(poll, index) in idleFlipBook" 
                        :key="index" 
                        :class="poll.voteStatus ? 'freeBook' : 'freeBooks'"
                        @click="goPath(`/read/idleFlipBookDetails?ID=${poll.ID}`)"
                    >
                        <!-- 投票标题 -->
                        <h4 :class="poll.voteStatus ? 'titles' : 'title'">{{ poll.title }}</h4>
                        
                        <!-- 来源和参与人数 -->
                        <div class="freeBook-info">
                            <span>{{ poll.source || '闲翻书·第20250720期' }}</span>
                            <span>{{ poll.countA + poll.countB || '0'}}人参与</span>
                        </div>
                        <!-- 投票选项 -->
                        <div  class="poll-options" v-if="!poll.voteStatus">
                            <button class="option-btn blue-option" @click="vote(poll,'A')">
                                {{ poll.fieldA }}
                            </button>
                            <button class="option-btn red-option" @click="vote(poll,'B')">
                                {{ poll.fieldB }}
                            </button>
                        </div>
                        <!-- 投票选项（未投票状态） -->
                        <div  v-else class="pocket">
                            <div class="pocket" v-for="(field, fieldIndex) in ['A', 'B']" :key="fieldIndex">
                                <div>
                                    <span>{{ poll[`field${field}`] }} {{ poll[`count${field}`] }}票</span>
                                </div>
                                <el-progress 
                                    :percentage="parseFloat((poll[`Ratio${field}`] || '0').replace('%', ''))" 
                                    :color="field === 'A' ? '#747FEB' : '#F4705E'"
                                ></el-progress>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- TOP热读 电子书-->
             <div v-if="(page_type==0&& page_data.column) || (page_type==1 && page_data && page_data && page_data.column && page_data.column[0])">
                <div v-for="(cbook,index) in page_data.column[0].sub||page_data.column[1].sub" :key="index" >
                    <div class="theme-list">
                        <h3>{{ cbook.title }}</h3>
                        <span @click="gotoList(cbook.id,cbook.product_type,cbook.title)">查看更多</span>
                    </div>
                    <div style="display: flex;gap: 25px;">
                        <div class="readBook" v-for="book in cbook.list" @click="gotoDetail(book.id,book.product_type)">
                            <img :src="book.img_url" alt="" class="bookimg">
                            <div class="titlenumber">
                            <p class="firstTitle" :title="book.title">{{book.title}}</p>
                            <p class="seconddesc" :title="book.author">{{book.author}}</p>
                            <!-- <span style="color: #a09a88;">
                                <img src="../../assets/readimg/defaultEar.svg" alt="">
                                {{book.user_view_count}}读过
                            </span> -->
                            </div>
                            <!-- <div class="ears" v-if="item === 1">
                                <img src="../../assets/readimg/jiangpai.png" alt="">
                            </div> -->
                        </div>
                    </div>
                </div>
             </div>
     

            <!-- 新书推荐 -->
            <!-- <div>
                <div class="theme-list">
                    <h3>新书推荐</h3>
                    <span>查看更多</span>
                </div>
                <div style="display: flex;gap: 10px;">
                    <div class="newBooks" v-for="(item, index) in 3" :key="index">
                        <div class="lefts">
                            <img src="../../assets/readimg/newBook.png" alt="">
                        </div>
                        <div class="right">
                            <h3 class="title">心之旅程·拥抱自我</h3>
                            <p class="author">安娜·塞内基耶</p>
                            <span class="descd">
                                描述哈哈哈哈哈哈哈哈哈哈传达出觉得很刺激的安徽别墅送不出胡说八道还是
                            </span>
                        </div>
                    </div>
                </div>
            </div> -->

            <!-- 有声书 普通用户-->
            <div v-if="page_type==0 &&  page_data&& page_data.column && page_data.column[2]">
                <div class="theme-list">
                    <h3>{{ page_data.column[2].title }}</h3>
                    <span @click="gotoList(page_data.column[2].id,page_data.column[2].product_type,page_data.column[2].title)">查看更多</span>
                </div>
                <div style="display: flex;gap: 25px;">
                    <div class="voidBooks" v-for="(book, index) in page_data.column[2].sub[0].list" :key="index">
                        <img :src="book.img_url" alt="" class="bookimg" @click="gotoAudioDetail(book.id,book.product_type)">
                        <div class="titlenumber">
                        <p class="firstTitle" @click="gotoAudioDetail(book.id,book.product_type)" :title="book.title">{{book.title}}</p>
                        <p class="seconddesc" :title="book.anchor">{{book.anchor}}</p>
                        <span style="color: #a09a88;">
                            <img src="../../assets/readimg/defaultEar.svg" alt="">
                            {{book.user_view_count}}读过
                        </span>
                        </div>
                    <div class="ear">
                        <img src="../../assets/readimg/bjear.svg" alt="">
                    </div>

                    </div>
                </div>
            </div>
            <!-- 有声书 企业用户-->
            <div v-if="page_type==1 && page_data &&  page_data.column && page_data.column[1]">
                <div class="theme-list">
                    <h3>{{ page_data.column[1].title }}</h3>
                    <span @click="gotoList(page_data.column[1].id,page_data.column[1].product_type,page_data.column[1].title)">查看更多</span>
                </div>
                <div style="display: flex;gap: 25px;">
                    <div class="voidBooks" v-for="(book, index) in page_data.column[1].list" :key="index">
                        <img :src="book.img_url" alt="" class="bookimg" @click="gotoAudioDetail(book.id,book.product_type)">
                        <div class="titlenumber">
                        <p class="firstTitle" @click="gotoAudioDetail(book.id,book.product_type)" :title="book.title">{{book.title}}</p>
                        <p class="seconddesc" :title="book.anchor">{{book.anchor}}</p>
                        <span style="color: #a09a88;">
                            <img src="../../assets/readimg/defaultEar.svg" alt="">
                            {{book.user_view_count}}读过
                        </span>
                        </div>
                    <div class="ear">
                        <img src="../../assets/readimg/bjear.svg" alt="">
                    </div>

                    </div>
                </div>
            </div>
        
            <!-- 课程 普通用户-->
            <div v-if="page_type==0 && page_data &&  page_data.column && page_data.column[3]">
                <div class="theme-list">
                    <h3>{{ page_data.column[3].title }}</h3>
                    <span @click="gotoList(page_data.column[3].id,page_data.column[3].product_type,page_data.column[3].title)">查看更多</span>
                </div>
                <div class="book">
                    <div class="book-item" v-for="(item, index) in page_data.column[3].list" :key="index">
                        <div class="lefts" @click="gotoCourDetail(item.id,item.product_type)">
                            <img :src="item.img_url" alt="">
                        </div>
                        <div class="right">
                            <h4 class="title" @click="gotoCourDetail(item.id,item.product_type)" :title="item.title">{{item.title}}</h4>
                            <p :title="item.anchor">{{item.anchor}}</p>
                            <div class="desc">
                                播放次数：{{item.user_view_count}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 课程 企业用户-->
            <div v-if="page_type==1 && page_data &&  page_data.column && page_data.column[2]">
                <div class="theme-list">
                    <h3>{{ page_data.column[2].title }}</h3>
                    <span @click="gotoList(page_data.column[2].id,page_data.column[2].product_type,page_data.column[2].title)">查看更多</span>
                </div>
                <div class="book">
                    <div class="book-item" v-for="(item, index) in page_data.column[2].list" :key="index">
                        <div class="lefts" @click="gotoCourDetail(item.id,item.product_type)">
                            <img :src="item.img_url" alt="">
                        </div>
                        <div class="right">
                            <h4 class="title" @click="gotoCourDetail(item.id,item.product_type)" :title="item.title">{{item.title}}</h4>
                            <p :title="item.anchor">{{item.anchor}}</p>
                            <div class="desc">
                                播放次数：{{item.user_view_count}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
       
    </div>
</template>

<script>
import defaultImg1 from '@/assets/readimg/defaultImg1.png';
import defaultImg2 from '@/assets/readimg/defaultImg2.png';
import api from '@/api/index.js';
import EmptyData from './components/emptyData.vue';
import ApiUrl from "../../js/apiUrl.js";
export default {
    name: 'ReadingHome',
    components: {
        EmptyData
    },
    data() {
        return {
            showCrop: {},
            themelist: [],
            idleFlipBook: [],
            user_token:'',
            page_data: undefined,
            page_type: undefined,
            home_page_banner: undefined,

        }
    },
    created() {
       
    },
    mounted() {
        this.user_token = localStorage.getItem("user_token")
        var option = {
            id: this.$route.query.id || "",
            token: this.$route.query.token || "",
        };
        this.CheckCorpAccount(option);
          //是否显示主题书单、闲翻书、视频荐书
        this.getCropShow();
        this.getHomeData()
        //主题书单
        this.getThemeList();
        //闲翻书
        this.getIdleFlipBook();
        this.bannerGet()
       
    },
    methods: {
        // 组件方法
        goPath(url){
            this.$router.push(url);
        },
        handleError(event){
            event.target.src = defaultImg1;
        },
        async getCropShow(){
            try{
                let res = await api.cropShow(this.user_token);
                if(res.data.status == 1){
                    this.showCrop = res.data.data;
                    localStorage.setItem("showCrop", res.data.data.isShowTheme);
                }
            }catch(error){
                this.$message.error(error.message);
            }
        },
        async getThemeList(){
            try{
                let res = await api.themeList({
                    pageSize: 3,
                    pageIndex: 0, 
                });
                if(res.data.status == 1){
                    this.themelist = res.data.data;
                }
            }catch(error){
                this.$message.error(error.message);
            }
        },
        async getIdleFlipBook(){
            try{
                let res = await api.leisureList({
                    pageSize: 3,
                    pageIndex: 0, 
                });
                if(res.data.status == 1){
                    this.idleFlipBook = res.data.data;
                }

            }catch(error){
                this.$message.error(error.message);
            }
        },
        //
        //首页其他数据
        getHomeData() {
            var that = this;
            this.Ajax(ApiUrl.home_list_get, {token: this.user_token}, function(data) {
                if (data) {
                    that.page_data = data;
                    that.page_type = data.page_type;
                }
                
            }, function() {
            });
        },
        gotoDetail(id, product_type) {//跳转详情
            if (product_type == 1) {//电子书
                this.$router.push({path: '/ebookdtl', query: {id: id}});
            } else if (product_type == 2) {//鲜读
                this.$router.push({path: '/ebookdtl', query: {id: id}});
            }
        },
        gotoAudioDetail(id, product_type){
            if(product_type==3){//有声书
                    this.$router.push({ path: '/Audtl', query: { id: id}});
            }else if(product_type==4){//课程
                this.$router.push({ path: '/couraudio', query: { id: id}});
            }
        },
        gotoCourDetail(id, product_type){
            if(product_type==3){//有声书
                    this.$router.push({ path: '/Audtl', query: { id: id}});
            }else if(product_type==4){//课程
                this.$router.push({ path: '/couraudio', query: { id: id}});
            }
        },
        gotoList(id, product_type, cate_name) {
             //跳转列表
            if (product_type == 1) {
                //电子书更多
                this.$router.push({
                    path: "/read/bookRecommend",
                    query: { id: id, product_type: product_type, cate_name: cate_name }
                });
            } else if (product_type == 2) {
                //鲜读更多
                //this.$router.push({path: 'AudioMoreList', query: {id: id, product_type: product_type, cate_name: cate_name}});
            } else if (product_type == 3) {
                //有声书更多
                this.$router.push({
                    path: "/read/bookRecommend",
                    query: { id: id, product_type: product_type, cate_name: cate_name }
                });
            } else if (product_type == 4) {
                //课程更多
                this.$router.push({
                    path: "/read/bookRecommend",
                    query: { id: id, product_type: product_type, cate_name: cate_name }
                });
            }
        },
        //banner
        bannerGet() {
            var that = this;
            this.Ajax(ApiUrl.banner_get,{token:this.user_token} ,function(data) {
                if (data) {
                    that.home_page_banner = data;
                }
            });
        },
         // 投票
         async vote(item, val) {
            const res = await api.fetchLeisureVote({ID: item.ID, field: val})
            if(res.status) {
                this.getIdleFlipBook()
            }else{
                this.$message.error(res.message);
            }
            setTimeout(()=>{
                this.$router.push({
                    path: '/read/idleFlipBookDetails',
                    query: { ID: item.ID },
                });
            },500)
        },

    },
    //
}
</script>

<style lang="scss" scoped>
::v-deep.el-carousel__item{
    text-align: center;
    img{
        width: 100%;
        height: 100%;
    }
   
}
::v-deep .el-carousel__indicator.is-active button{
    background: red;
}
::v-deep .el-carousel__indicator--horizontal{
    .el-carousel__button{
        width: 8px;
        height: 8px;
        border-radius: 50%;
        opacity:1
    }
}
.banner {
    height: 400px; // 设置banner高度
    margin: 0 auto; 
    

}
.contents {
    width: 90%;
    max-width: 1200px;
    margin: 0 auto; // 居中内容
    background-color: #f7f7f7 !important;
}
.theme-list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 35px 0;
    h3 {
        font-size: 24px;
        font-weight: bold;
    }
    span {
        color: red; // 设置查看更多的颜色
        cursor: pointer; // 鼠标悬停时显示为手型
    }
}
.bookList {
    display: flex;
    gap: 20px;
    .book-item {
        width: 33%;
        background-color: #fff;
        border-radius: 10px;
        padding-bottom: 10px;
        cursor: pointer;
        transition: transform 0.3s ease;

        &:hover{
            transform: scale(1.05);
            transition: transform 0.3s ease;
        }

        .imgs {
            width: 100%;
            height: 70%;
            object-fit: cover; // 保持图片比例填充
            border-radius: 10px 10px 0 0; // 圆角效果
        }
        .tit{
            padding-left: 20px;
            margin: 7px 0px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        .button {
            display: inline-block;
            margin-right: 15px;
            width: 80px;
            height: 30px;
            background-color: #ffefef;
            text-align: center;
            line-height: 30px;
            border-radius: 5px;
            color: red;
        }
      
        .book-icons {
            display: flex;
            padding: 0 20px 15px;
            gap: 15px;
            
            .icon-item {
                display: flex;
                align-items: center;
                color: #e6564e;
                background: #ffefef;
                border-radius: 5px;
                padding: 8px 14px;
                gap: 10px;
                
                .icon-placeholder {
                    width: 16px;
                    height: 16px;
                }
                
                span {
                    font-size: 12px;
                }
            }
        }

    }
}
// 闲翻书样式 - 参考idleFlipBook.vue
.freeBook, .freeBooks {
    width: 33.33%;
    background: linear-gradient(180deg, #FDF3F3 0%, #fff 100%);
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transition: transform 0.2s ease;
    cursor: pointer;
    
    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
    }

    .title, .titles {
        font-size: 16px;
        font-weight: 600;
        color: #333;
        margin-bottom: 8px;
        line-height: 1.4;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }
    
    .titles {
        font-size: 14px;
        height: 2.8em;
    }
    
    .title {
        height: 5.6em;
    }

    .freeBook-info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 16px;
        
        span {
            font-size: 12px;
            color: #666;
        }
    }
    
    .pocket {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-top: 10px;
        
        .button1, .button2 {
            padding: 14px 0;
            border: none;
            font-size: 14px;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.2s ease;
            flex: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            color: #fff;
        }
        
        .button1 {
            background: #747FEB;
            border-radius: 8px 0px 8px 8px;
            
            &:hover {
                background: #5a6fd8;
            }
        }
        
        .button2 {
            background: #F4705E;
            border-radius: 8px 8px 8px 0px;
            
            &:hover {
                background: #e55a4b;
            }
        }
    }
}

// 投票结果样式
.freeBook {
    .pocket {
        flex-direction: column;
        gap: 12px;
        
        > div {
            width: 100%;
            
            > div {
                display: flex;
                align-items: center;
                gap: 10px;
                margin-bottom: 4px;
                
                span {
                    font-size: 12px;
                    color: #666;
                }
            }
        }
    }
}
.poll-options {
    display: flex;
    align-items: center;
    gap: 8px;

.option-btn {
    padding: 10px 16px;
    border: none;
    // border-radius: 6px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 14px 0;

    &.blue-option {
        background: #747FEB;
        border-radius: 8px 0px 8px 8px;
        color: #fff;

        &:hover {
            background: darken(#747FEB, 10%);
        }
    }

    &.red-option {
        background: #F4705E;
        border-radius: 8px 8px 8px 0px;
        color: #fff;

        &:hover {
            background: darken(#F4705E, 10%);
        }
    }
}
}
// Element Plus 进度条样式优化
:deep(.el-progress) {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

:deep(.el-progress__text) {
    margin-left: 8px !important;
    font-size: 12px !important;
}

:deep(.el-progress-bar) {
    padding-right: 4px !important;
}
// top热读
.readBook {
   width: 15%;
   border-radius: 10px;
   background-color: #fff;
    position: relative;
   .bookimg{
    width: 100%;
    height: auto;
    border-radius: 10px 10px 0 0; // 圆角效果
    cursor: pointer;
   } 
   .titlenumber {
    padding: 20px;
    .firstTitle {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 5px;
        color: #181c18;
        cursor: pointer;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .seconddesc {
        color: #a09a88; // 设置作者文字颜色
        margin-bottom: 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
   }
}
.newBooks {
    width: 36%;
    display: flex;
    background-color: #fff;
    border-radius: 10px;
    height: 207px;
    .lefts {
        width: 70%;
        margin-right: 20px;
        img{
            width: 100%;
            height: 100%;
            border-radius: 10px; // 圆角效果
        }
    }
    .right {
        box-sizing: border-box;
        padding-top: 30px;
        padding-right: 10px;
        .title {
            margin-bottom: 20px;
        }
        .author {
            margin-bottom: 15px;
            box-sizing: content-box;
            color: #666; // 设置作者文字颜色
        }
        .descd {
        background-color: #f7f7f7;
        font-size: 15px;
        padding: 10px;
        box-sizing: border-box;
        }
        
    }
}
// top热读
.voidBooks {
   width: 15%;
   border-radius: 10px;
   background-color: #fff;
   position: relative;
   .bookimg{
    width: 100%;
    height: auto;
    border-radius: 10px 10px 0 0; // 圆角效果
    cursor: pointer;
   } 
   .titlenumber {
    padding: 20px;
    .firstTitle {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 5px;
        color: #181c18;
        cursor: pointer;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .seconddesc {
        color: #a09a88; // 设置作者文字颜色
        margin-bottom: 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
   }
}
.ear {
    position: absolute;
    top: 14px;
    right: 20px;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: #969e9f;
    text-align: center;
    line-height: 35px;
    img {
        width: 60%;
        height: 65%;
    }
}
.ears {
    position: absolute;
    top: -17px;
    right: -3px;
    width: 68px;
    height: 100px;
    img {
        width: 100%;
        height: 100%;
    }
}
.book {
            display: flex;
            margin-top: 30px;
            flex-wrap: wrap; // 允许换行
            justify-content: space-between;
            .book-item {
                display: flex;
                width: 32%;
                margin-bottom: 30px;
                background-color: #fff;
                border-radius: 10px;
                cursor: pointer;
                align-items: center;
                .lefts {
                    width: 150px;
                    max-height: 210px; 
                    img {
                        width: 100%;
                        max-height: 100%;
                        border-radius: 10px;
                    }
                }
                .right {
                    padding: 20px 30px;
                    .title {
                        margin-bottom: 15px;
                        box-sizing: border-box;
                    }
                    .desc {
                        margin-top: 65px;
                        box-sizing: border-box;
                    }
                }
            }
        }
</style>